import "../stylesheets/ixcanul.scss";
import pusherChannels from "./pusher_channels";
import UI_UTILS from "./ui_util";
import html_template from "./html_template";
import pane from "./pane";
import contextMenu from "./context_menu";
import uploader from "./uploader";
import tephraManager from "./tephra_manager";
import fileHistory from "./fileHistory";
import bindGlobalCommands from "./actions/bindGlobalCommands";
import _tree from "./tree";
import loadFile from "./actions/loadFile";
import passiveSave from "./actions/passiveSave";
import createFolder from "./actions/createFolder";
import createFile from "./actions/createFile";
import saveFile from "./actions/saveFile";
import Tabs from "./tabs";
import searchFolder from "./search_folder";
import ace from "ace-builds";
import "./ace_webpack_resolver.js";
import "emmet-core";
import "ace-builds/src-noconflict/ext-language_tools";
import emmet from "ace-builds/src-noconflict/ext-emmet";
import resolveAceMode from "./actions/resolveMode";

import "./gascript";
import { GlobalRender, HB } from "./utils";
import ReplaceTheme from "./actions/replaceTheme";
import { getTrail, addTrail } from "./trail";

// resolve ESM aceBuilds
const $modURLs = ace.config.all().$moduleUrls;
Object.entries($modURLs).forEach(([name, module]) => {
  ace.config.setModuleUrl(name, module.default);
});

// extend emmet to allow our custom mode
emmet.isSupportedMode = function(mode) {
  if (!mode) return false;
  if (mode.emmetConfig) return true;
  const id = mode.$id || mode;
  return /css|less|scss|sass|stylus|html|liquid|volcanicLiquid|php|twig|ejs|handlebars/.test(id);
};

window.$ = window.jQuery = $;
if (!window.CodeEditor) {
  window.CodeEditor = {};
}

CodeEditor.Tree = _tree;
CodeEditor.UI = UI_UTILS;
CodeEditor.Templates = html_template;
CodeEditor.Pane = pane;
CodeEditor.ContextMenu = contextMenu;
CodeEditor.Uploader = uploader;
CodeEditor.TephraManager = tephraManager;
CodeEditor.fileHistory = fileHistory;

window.editor = {};

window.editorLoaded = new Promise(r => {
  console.log("editor_loaded in promise");
  document.addEventListener("editor_loaded", () => {
    console.log("editor_loaded");
    r(true);
  });
});

window.editors = [];
window.selectedNode = undefined;
window.selectedNodeAvailable = true;
window.aceSessions = {};
window.Panes = undefined;
window.socketId = null;

const pjson = require("../../package.json");

CodeEditor.getEditorById = id => {
  const E = editors.filter(e => e.container.id === id);
  return E[0];
};

CodeEditor.hide = () => (editor.container.style.display = "none");
CodeEditor.show = () => (editor.container.style.display = "block");
CodeEditor.resize = () => editors.forEach(editor => editor.resize());
CodeEditor.GUID = () => {
  /**
   * @function s4
   * @return {type} {description}
   */
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + "-" + s4();
};

CodeEditor.Main = (function() {
  /**
   * @function Main
   * @param  {type} options {description}
   */
  function Main() {
    console.log(CodeEditor.Main.version());
    this.init();
  }

  Main.prototype.init = function() {
    const { loadDependencies } = require("./actions/loadExternalDeps");
    $(document.body).addClass("loaded");
    const socket_id = CodeEditor.GUID() + "_" + Date.now();
    window.socketId = socket_id;

    loadDependencies();

    $(window).on("load", function() {
      GlobalRender();
      $(".page-container").addClass("beta-theme");
      CodeEditor.bindChannels = pusherChannels;
      CodeEditor.bindChannels.subscribe();
      CodeEditor.bindChannels.presenceChannel($(".editor-wrapper").attr("data-theme-uuid"));
      CodeEditor.bindChannels.setSocket(socket_id);
      new CodeEditor.UI();
      window.Templates = new CodeEditor.Templates();
      new CodeEditor.Pane();
      new CodeEditor.Tree();
      window.ContextMenu = new CodeEditor.ContextMenu();
      new CodeEditor.Uploader();
      new CodeEditor.TephraManager();
      CodeEditor.SearchFolder = new searchFolder();
      CodeEditor.Main.beforeClose();
      document.dispatchEvent(new CustomEvent("editor_loaded"));
      return false;
    });
  };
  // version
  Main.version = function() {
    return pjson.version;
  };

  Main.batchDestroyNodes = require("./actions/batchDestroyNodes");

  Main.replaceTheme = ReplaceTheme;

  Main.mode = function(node) {
    let rootParent = node.getParentList()[1];
    if (/^(tephra|legacy)$/i.test(rootParent.title)) return "tephra";
    return "normal";
  };

  Main.themeId = function() {
    return $(".editor-wrapper").data("theme-id");
  };
  Main.themeUUID = () => document.querySelector(".editor-wrapper").getAttribute("data-theme-uuid");

  Main.themeName = function() {
    return $("title")
      .text()
      .replace(" - Ixcanul", "");
  };

  Main.CSRF_TOKEN = () => document.head.querySelector('meta[name="csrf-token"]').content;

  Main._passiveSave = passiveSave;

  Main.createFolder = createFolder;

  Main.createFile = createFile;

  Main.saveFile = saveFile;

  Main.loadFile = loadFile;
  /**
   * Refreshes the editor content and binds it to the latest active ace session available
   * NO PARAMS NEEDED
   */
  Main.refreshContent = () => {
    console.log("refresh content");

    if (aceSessions === {}) {
      HB.setContext({ trail: getTrail() });
      HB.notify("aceSessions is empty");
      alert("editor crashed, contact support! with relavant information about your flow");
    }
    let node = Tabs.getActiveTab().config.node;
    addTrail(`Refresh editor for node ${node?.title}`);
    if (typeof node !== "undefined") {
      editor.setSession(aceSessions["session_" + node.key]);
    } else {
      editor.setValue("");
      editor.container.style.display = "none";
    }
  };

  /**
   * Updates the editor's session
   * @param {Object} node an object representing a node on the file tree or the required fields in the save api
   * @param {Boolean} clearUndo set to ture to rest the UndoManager.
   */
  Main.updateEditor = (node, clearUndo) => {
    console.log("updateEditor()");
    addTrail(`Update editor for node ${node.title}`);
    let mode = node.title.split(".").pop();
    CodeEditor.hide();
    clearUndo = typeof clearUndo != "undefined" ? clearUndo : true;
    if (typeof aceSessions["session_" + node.key] === "undefined") {
      const { data: activeData = { path: null } } = tree.getActiveNode() || {};
      const activeNodePath = activeData.path;
      HB.setContext({
        trail: getTrail(),
        panes: {
          stacks: Panes.root.getItemsByType("stack").map(i => i.config.id),
          tabs: Panes.root.getItemsByType("component").map(i => i.config.id)
        },
        isSelectedNodeDefined: selectedNode ? true : false,
        activeNodePath
      });
      HB.notify("A session node is undefined");
      alert("Ixcanul crashed, contact the ixcanul team and check the console ");
      console.log("undefined session");
    }
    editor.setSession(aceSessions["session_" + node.key]);
    CodeEditor.show();
    editor.focus();
    if (clearUndo === true) {
      editor.session.getUndoManager().markClean();
      editor.getSession().setUndoManager(new ace.UndoManager());
    }
    if (editor.selection !== null) {
      editor.clearSelection();
    }
    resolveAceMode(mode);
  };

  /**
   * A file reference generator, accepts tree nodes and API nodes.
   * @param {Object} node an object representing a node on the file tree or the required fields in the save api
   * @param {String} filename the name of the file
   * @param {String} fileType the file_type, needs to be a valid file type
   * @return {String} the reference
   */
  Main.generateReference = function(node, filename, fileType) {
    let reference;
    if (node && typeof node == "string") {
      const re = new RegExp(/snippets\/|assets\/javascripts\/|assets\/stylesheets\/|assets\/|layouts\/|templates\//);
      const matchExtra = node.match(re);
      if (!matchExtra) {
        // the passed string is a refrence
        return node;
      }
      reference = matchExtra.input.substr(matchExtra[0].length);
      if (CodeEditor.Main.fileType(node) === "asset" && matchExtra.input.match(/stylesheets\/|javascripts\//)) {
        // reference = reference.slice(0, (reference.split('.').pop().length + 1) * -1);
      }
      return reference;
    } else if (CodeEditor.Main.mode(node) === "tephra") {
      reference = node.parent.title + "/" + filename;
    } else if (node.getParentList().length > 2 && fileType !== "asset") {
      reference =
        node
          .getParentList()
          .slice(2)
          .map(p => p.title)
          .join("/") +
        "/" +
        filename;
    } else if (
      node.getParentList().length >= 3 &&
      fileType == "asset" &&
      (node
        .getParentList()
        .slice(2)
        .map(p => p.title)
        .includes("images") ||
        node
          .getParentList()
          .slice(2)
          .map(p => p.title)
          .includes("fonts"))
    ) {
      reference =
        node
          .getParentList()
          .slice(2)
          .map(p => p.title)
          .join("/") +
        "/" +
        filename;
    } else if (node.getParentList().length > 3 && fileType == "asset") {
      reference =
        node
          .getParentList()
          .slice(3)
          .map(p => p.title)
          .join("/") +
        "/" +
        filename;
    } else {
      reference = filename;
    }
    return reference;
  };

  /**
   * Generate file path based on file tree node, accepts tree nodes
   * @function Main.generatePath
   * @param {Object} node an object representing a node on the file tree or the required fields in the save api
   * @param {String} filename the filename
   * @return {String} {description}
   */
  Main.generatePath = function(node, filename) {
    let folderReference;
    let parents;
    let path;
    parents = node.getParentList();
    parents.shift();

    folderReference = $(parents)
      .map(function() {
        return this.title;
      })
      .get()
      .join("/");

    path = (folderReference + "/" + filename).replace(/^\//, "");
    console.log(path);
    return path;
  };

  /**
   * @function CodeEditor.Main.fileType
   * @param  {object} node or {String} as the path
   * @return {string} the file type
   */
  Main.fileType = function(node) {
    const re = new RegExp(/snippets\/|assets\/|layouts\/|templates\//);
    let fileType;
    if (typeof node === "string") {
      fileType = node.match(re) ? node.match(re)[0].slice(0, -2) : node;
      return fileType;
    } else if (node.data.root === true) {
      fileType = node.data.file_type;
    } else if (node.getParentList().length > 1) {
      fileType = node.getParentList()[1].data.file_type;
    } else {
      fileType = "snippet";
    }
    return fileType;
  };

  /**
   * Update paths index.
   * @function Main.updatePaths
   * @param  {type} node {description}
   * @return {type} {description}
   */
  Main.updatePaths = function() {
    let activeNode;
    let children;
    let data;
    data = [];
    children = [];
    activeNode = tree.getActiveNode();
    activeNode.visit(function(node) {
      children.push(node);
    });

    $.each(children, function(index, child) {
      const file_type = child.data.file_type;
      data.push({
        id: child.data.secure_random,
        folder: child.folder,
        file_type: file_type,
        reference: CodeEditor.Main.generateReference(child, child.title, file_type),
        path: CodeEditor.Main.generatePath(child, child.title)
      });
    });

    return $.ajax({
      type: "patch",
      headers: {
        "x-csrf-token": $("meta[name='csrf-token']").attr("content")
      },
      url: "/api/v1/code_editor/update_path",
      data: {
        children: data,
        theme_id: CodeEditor.Main.themeId(),
        socket_id: window.socketId
      },
      success: function(data) {
        $.each(children, function(index, child) {
          child.data.reference = data.files[index].reference;
          child.data.path = data.files[index].path;
        });
      }
    });
  };

  Main.oldReference = function(node, newName, oldName) {
    let reference = Main.generateReference(node, node.title, node.data.file_type);
    return reference.replace(newName, oldName);
  };

  /**
   * Main.bindCommands enables ixcanul's basic keyboard commands
   **/
  Main.bindCommands = bindGlobalCommands;
  /**
   * Adds a new instace of the Ace editor.
   * @param {String} id a unique ID for the new editor element
   * @note all options are set up internally in this method
   */
  Main.attachEditor = async function(id) {
    // const ayu_ace = require('ayu-ace');
    // const ayu_light = 'ayu-ace/light';
    // const ayu_mirage = 'ayu-ace/mirage';
    // const ayu_dark =  'ayu-ace/dark';
    const langTools = ace.require("ace/ext/language_tools");
    function getTextCompleter() {
      const Range = ace.require("ace/range").Range;
      const splitRegex = /[^a-zA-Z_$\-\u00C0-\u1FFF\u2C00-\uD7FF\w]+/;

      function getWordIndex(doc, pos) {
        const textBefore = doc.getTextRange(Range.fromPoints({ row: 0, column: 0 }, pos));
        return textBefore.split(splitRegex).length - 1;
      }
      function wordDistance(doc, pos) {
        const prefixPos = getWordIndex(doc, pos);
        const words = doc.getValue().split(splitRegex);
        const wordScores = Object.create(null);

        const currentWord = words[prefixPos];

        words.forEach(function(word, idx) {
          if (!word || word.length < 3 || word === currentWord) return;
          if (/^(-)*\d+[a-z]*$/i.test(word)) return;
          const distance = Math.abs(prefixPos - idx);
          const score = words.length - distance;
          if (wordScores[word]) {
            wordScores[word] = Math.max(score, wordScores[word]);
          } else {
            wordScores[word] = score;
          }
        });
        return wordScores;
      }

      return {
        getCompletions: function(editor, session, pos, prefix, callback) {
          let wordScore = wordDistance(session, pos);
          // /(em|px|\%|vh|vw|em)$/i.test("")
          const wordList = Object.keys(wordScore);
          console.log({ wordScore });
          callback(
            null,
            wordList.map(function(word) {
              return {
                caption: word,
                value: word,
                score: wordScore[word],
                meta: "local"
              };
            })
          );
        }
      };
    }
    const staticWordCompleter = {
      getCompletions: function(editor, session, pos, prefix, callback) {
        const { $modeId = "" } = session;
        if (/liquid$/i.test($modeId)) {
          let wordList = tree.findAll(i => i.folder && i.data.tephra).map(i => i.data.reference);
          let completer = [
            {
              caption: "reset_assigns",
              value: "reset",
              meta: "Liquid tag",
              snippet: "{% reset_assigns '${1:assign_name1,assign_name_2}' %}",
              score: 1000
            },
            {
              caption: "var",
              value: "var",
              meta: "Liquid tag",
              snippet: "{% var ${1:assign_name} | default: ${2:'value'} %}",
              score: 1000
            },
            ...wordList.map(function(word) {
              return {
                caption: word,
                value: "tephra",
                snippet: `{% tephra '${word}', { \${1:option: 'value'} } | { hex: '${CodeEditor.GUID()}' } %}`,
                meta: "Tephra",
                score: 1
              };
            })
          ];
          callback(null, completer);
        }
      }
    };
    langTools.setCompleters([
      getTextCompleter(),
      staticWordCompleter,
      langTools.keyWordCompleter,
      langTools.snippetCompleter
    ]);

    window.editor = ace.edit(id);
    window.editors.push(editor);
    window.beautify = ace.require("ace/ext/beautify");
    window.editor.setTheme("ace/theme/tomorrow_night");
    window.editor.$blockScrolling = Infinity;
    window.editor.setShowPrintMargin(false);
    CodeEditor.Main.editorCommands();

    editor.setOptions({
      enableBasicAutocompletion: true,
      enableSnippets: true,
      enableEmmet: true,
      enableLiveAutocompletion: false,
      // enableLiveAutocompletion: true,
      fontSize: "calc(10px + 0.12vw)",
      scrollPastEnd: 0.5,
      autoScrollEditorIntoView: true,
      wrap: true,
      fontFamily: 'Menlo, Monaco, "Courier New", monospace'
    });

    editor.container.style.lineHeight = "1.4";
    editor.renderer.updateFontSize();

    Main.fileSaveHandler = function() {
      console.log("file changed");
      if (window.editor.session.getUndoManager().isClean()) {
        Tabs.getActiveTabHeader()
          .find(".file_save")
          .attr("class", "file_save loaded hide");
      } else {
        Tabs.getActiveTabHeader()
          .find(".file_save")
          .attr("class", "file_save not_saved");
      }
      if (Panes.root.ActiveNode.componentName === "editor component") {
        Tabs.getActiveTab().config.node.data.content = editor.getValue();
      }
    };
    window.editor.on("input", CodeEditor.Main.fileSaveHandler);
  };

  /**
   * Attaches all needed commands to the ace editor
   */
  Main.editorCommands = () => {
    editor.commands.removeCommand("goToNextError");
    editor.commands.addCommand({
      name: "showKeyboardShortcuts",
      exec: function(editor) {
        ace.config.loadModule("ace/ext/keybinding_menu", function(module) {
          module.init(editor);
          editor.showKeyboardShortcuts();
        });
      }
    });
    editor.commands.addCommand({
      name: "Foldall",
      bindKey: { win: "Ctrl-Alt-]", mac: "Command-Alt-]" },
      exec: function(editor) {
        editor.session.foldAll();
      }
    });
    editor.commands.addCommand({
      name: "UnFoldall",
      bindKey: { win: "Ctrl-Alt-[", mac: "Command-Alt-[" },
      exec: function(editor) {
        editor.session.unfold();
      }
    });
  };

  /**
   * Disable the editor
   * @function Main.disableEditor
   * @return {Boolean}
   */
  Main.disableEditor = function() {
    window.editor.setOption("readOnly", true);
    window.editor.container.style.opacity = 0.85;
    window.editor.renderer.$cursorLayer.element.style.opacity = 0;
    $("body").append(
      '<div id="readOnly-notif" class="notification" style="background: rgba(255,255,255,0.5); z-index:99; color: black;padding:15px;position: fixed;bottom: 0;right: 30px;"><p class="m0">readOnly mode: ON </p></div>'
    );
    return window.editor.getOption("readOnly");
  };

  /**
   * Disable the editor
   * @function Main.enableEditor
   * @return {Boolean}
   */
  Main.enableEditor = () => {
    window.editor.setOption("readOnly", false);
    window.editor.container.style.opacity = 1;
    window.editor.renderer.$cursorLayer.element.style.opacity = 1;
    $("#readOnly-notif").remove();
    return !window.editor.getOption("readOnly");
  };

  Main.beforeClose = () => {
    window.onbeforeunload = function(e) {
      if ($(".file_save.not_saved").length > 0) {
        const dialogText = "You have unsaved files!";
        e.returnValue = dialogText;
        return dialogText;
      }
    };
  };

  /**
   * @function convertFileToDataURL
   * @param  {string} url The file url to convert
   * @return {promise} when resolved it returns the blobURL
   */
  Main.convertFileToDataURL = url => {
    return fetch(url)
      .then(response => response.blob())
      .then(
        blob =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(blob);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );
  };

  /**
   * should sort folders in the tree (this code was written by another dev... I don't remember how it works)
   * @function orderFoldersFirst
   * @param  {object} tree The tree object
   * @param  {Function} cmp not sure
   * @param  {any} deep not sure
   */
  Main.orderFoldersFirst = function(tree, cmp, deep) {
    // this --> window.tree.getRootNode()
    let i;
    let l;
    let cl = tree.children;
    if (!cl) {
      return;
    }
    cmp =
      cmp ||
      function(a, b) {
        let x = (a.isFolder() ? "0" : "1") + a.title.toLowerCase();
        let y = (b.isFolder() ? "0" : "1") + b.title.toLowerCase();
        return x === y ? 0 : x > y ? 1 : -1;
      };
    cl.sort(cmp);
    if (deep) {
      for (i = 0, l = cl.length; i < l; i++) {
        if (cl[i].children) {
          CodeEditor.Main.orderFoldersFirst(cl[i], cmp, "$norender$");
        }
      }
    }
    if (deep !== "$norender$") {
      tree.render();
    }
    tree.triggerModifyChild("sort");
  };

  Main.nodeExists = object => {
    if (!object) {
      console.error("Main.nodeExists:: object can't be undefined 😅 ");
      return false;
    }
    if (!(object.node || object.path)) {
      throw new Error("passed argument to Main.nodeExists is invalid 👎  👉 💩 ");
    }
  };

  Main.clipBoard = () => {};
  Main.loadFavicon = url => {
    const favicon = document.createElement("link");
    favicon.rel = "icon";
    favicon.type = "image/x-icon";
    favicon.href = url;
    document.head.appendChild(favicon);
  };
  return Main;
})();

new CodeEditor.Main();

if (!Array.prototype.last) {
  Array.prototype.last = function() {
    return this[this.length - 1];
  };
}

if (!String.prototype.postfix) {
  String.prototype.postfix = function(c) {
    return this.split(c || "").pop();
  };
}
/**
 * String.decodeHtmlEntity decodes HTML entities to raw HTML text
 * this function doesn't require any params
 * @return {String}
 */
String.prototype.decodeHtmlEntity = function() {
  return this.replace(/&#(\d+);/g, function(match, dec) {
    return String.fromCharCode(dec);
  });
};
/**
 * String.encodeHtmlEntity encodes raw HTML text to HTML entities
 * This function doesn't require any params
 * @return {String}
 */
String.prototype.encodeHtmlEntity = function() {
  let buf = [];
  let i;
  for (i = this.length - 1; i >= 0; i--) {
    buf.unshift(["&#", this[i].charCodeAt(), ";"].join(""));
  }
  return buf.join("");
};

$.fn.extend({
  /**
   * $(DOM).toggleText toggles text on each call (extended from Jquery $.fn.)
   * @param {String} a first case string to be toggled
   * @param {String} b last case string to be toggled
   * @return {String}
   */
  toggleText: function(a, b) {
    return this.text(this.text() === b ? a : b);
  }
});

HTMLElement.prototype.isCursorOver = false;
document.addEventListener("mousemove", function(event) {
  HTMLElement.prototype.isCursorOver = function() {
    let rect = this.getBoundingClientRect();
    if (
      !(event.clientX < rect.left || event.clientX > rect.right) &&
      !(event.clientY < rect.top || event.clientY > rect.bottom)
    ) {
      return true;
    }
    return false;
  };
});

window.addEventListener("offline", () => {
  CodeEditor.UI.notif.error({
    id: "ixc-offline-error",
    message: "ERR: you are offline, save your code locally!",
    progressBar: false,
    title: "Oops..!",
    timeout: 99999,
    position: "topRight"
  });
});

window.addEventListener("online", () => {
  CodeEditor.UI.notif.success({
    replace: true,
    id: "ixc-offline-error",
    message: "You are back online",
    progressBar: false,
    title: "Online!",
    timeout: 2000
  });
});

window._DANGER_forceTephraSCSSRefresh = async function() {
  const files = tree.findAll(i => !i.folder && i.data.tephra && i.data.path.endsWith(".scss"));
  const promise = new Promise.all(
    files.map(async file => {
      CodeEditor.Main.loadFile(
        file,
        "asset",
        file.data.path,
        function(node, data) {
          CodeEditor.Main.saveFile(node, node.title, data, false);
          console.log(data, node);
        },
        true
      );
    })
  );
  promise.then(() => console.log("done"));
  CodeEditor.Main.loadFile;
};
